/**
 * Voucher API error codes that have a matching translation key, so they can be
 * written straight into voucherErrorAtom and rendered inline.
 *
 * Anything else must NOT be written through: apiRequest synthesises
 * `errorCode: "UNKNOWN_ERROR"` for any non-JSON or unrecognised error body
 * (see handleResponse), and that string has no bare translation key — react-intl
 * would render the literal "UNKNOWN_ERROR" to the customer.
 */
export const KNOWN_VOUCHER_ERROR_KEYS = [
    "paid_amount_exceeds_amount_to_pay",
    "cannot_use_voucher_twice_per_booking",
    "not_enough_on_voucher",
    "voucher_used",
    "voucher_not_found_from_booking",
    "voucher_not_found",
    "voucher_not_found_from_exchange_operation"
];

/**
 * Maps a voucher API error code to a translation key that is guaranteed to
 * resolve. `fallback` is what an unrecognised code degrades to, and differs by
 * caller: applying a bad code is most likely an invalid voucher, while a failed
 * removal says nothing about the voucher's validity.
 */
export function toVoucherErrorKey(errorCode?: string, fallback: string = "voucher_not_found"): string {
    return KNOWN_VOUCHER_ERROR_KEYS.includes(errorCode ?? "") ? errorCode! : fallback;
}
